export default __webpack_public_path__ + "static/media/58.d28a4cf7.png";